/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  var LOW_ALERT = 'severity-low';
  var MED_ALERT = 'severity-medium';
  var HIGH_ALERT = 'severity-high';
  function stringToHash(string) {
    var hash = 0;
    if (string.length === 0) return hash;
    for (var i = 0; i < string.length; i++) {
      var char = string.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash;
    }
    return hash;
  }
  function onCloseClicked(alert) {
    sessionStorage.setItem(stringToHash(alert.innerHTML), 'stored alert hash');
    alert.classList.add('not-visible');
  }
  function addCloseEventListeners(props) {
    var _loop = function _loop() {
      var alert = props.alerts[i];
      var closeButton = alert.querySelector('.close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          onCloseClicked(alert);
        });
      }
    };
    for (var i = 0; i < props.alerts.length; i++) {
      _loop();
    }
  }
  function sortAlertsBasedOnSeverity(props) {
    var _document$querySelect;
    var unsortedAlerts = props.alerts;
    var lowAlerts = [];
    var medAlerts = [];
    var highAlerts = [];
    for (var i = 0; i < unsortedAlerts.length; i++) {
      var alert = props.alerts[i];
      if (alert.classList.value.includes(LOW_ALERT)) {
        lowAlerts.push(alert);
      }
      if (alert.classList.value.includes(MED_ALERT)) {
        medAlerts.push(alert);
      }
      if (alert.classList.value.includes(HIGH_ALERT)) {
        highAlerts.push(alert);
      }
    }
    (_document$querySelect = document.querySelector('.region--site-alert')).replaceChildren.apply(_document$querySelect, _toConsumableArray(highAlerts.concat(medAlerts).concat(lowAlerts)));
  }
  function filterDismissedAlerts(props) {
    for (var i = 0; i < props.alerts.length; i++) {
      var alert = props.alerts[i];
      if (sessionStorage.getItem(stringToHash(alert.innerHTML)) == null) {
        alert.classList.remove('not-visible');
      }
    }
  }
  function init(props) {
    sortAlertsBasedOnSeverity(props);
    addCloseEventListeners(props);
    filterDismissedAlerts(props);
  }
  window.addEventListener('load', function () {
    var siteAlert = document.querySelector('.region--site-alert');
    if (siteAlert) {
      var alerts;
      var checkAlertsLoaded = setInterval(function () {
        if (siteAlert.children.length > 0) {
          alerts = siteAlert.children;
          clearInterval(checkAlertsLoaded);
          init({
            alerts: alerts
          });
        }
      }, 250);
    }
  });
})();